import styled from 'styled-components';

export const Title = styled.h1`
  z-index: 5;
  max-width: 18ch;
  color: #160647;
  font-family:
    Gilroy,
    Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif;
  font-size: 64px;
  text-align: center;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -2px;
  position: relative;
  @media (max-width: 767px) {
    font-size: 34px;
  }
`;

export const BoxStyled = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px 0;
  @media (max-width: 950px) {
    margin: 100px auto 16px auto;
    width: 80%;
  }
`;

export const BoxDescription = styled.div`
  color: rgb(85 94 103);
  font-size: 20px;
  text-align: center;
  margin-top: 5px;
  font-weight: 500;
  font-family:
    Inter,
    Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif;
  letter-spacing: -0.2px;
  line-height: 140%;
  max-width: 950px;
  @media (max-width: 767px) {
    font-size: 14px;
  }
`;
